export interface ISwapFailureRateReportRow {
    rccapId: number | null;
    swapChainNumber: number | null;
    swapClusterNumber: number | null;
    swapPositionNumber: number | null;
    donorCenterAlias: string;
    donorAlias: string;
    recipientCenterAlias: string;
    recipientAlias: string;
    outcome: 'Completed' | 'Failed';
    outcomeDate: string;
    currentStatusId: number | null;
}
